import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";

export const getClientsCellProps = (
  requirements: IRequirementResponse[]
): WSTableCellProps | undefined => {
  const requirementsLength = requirements.length;

  // If there is only one requirement, don't put clients cell, it will display client name in the table
  if (requirementsLength > 1) {
    return {
      text: `${requirementsLength} clients`
    };
  }

  return undefined;
};
